import { Checkbox } from "rsuite";

type checkBoxProps = {
  id: number;
  title: string;
  defaultData: boolean | undefined;
  setFormCategoryInput: any;
  setCheckBoxError?: (value: boolean) => void;
};

const InputCheckbox = ({
  id,
  title,
  defaultData,
  setFormCategoryInput,
  setCheckBoxError
}: checkBoxProps) => {
  return (
    <Checkbox
      value={id}
      id={String(id)}
      defaultChecked={defaultData}
      onChange={(value, checked) => {
        if (checked && value) {
          setFormCategoryInput((values: any) =>
            [...values].length > 0 && !values.includes(value)
              ? [...values, value]
              : [value]
          );

          if(setCheckBoxError){
            setCheckBoxError(false)
          }
        } else {
          setFormCategoryInput((values: number[]) =>
            [...values].filter((id: number) => id !== value)
          );

          if(setCheckBoxError){
            setCheckBoxError(true)
          }
        }
      }}
    >
      {title}
    </Checkbox>
  );
};

export default InputCheckbox;
